/**
 * @fileoverview Service module for configuration loading.
 *
 * This module provides the ConfigService and configures it to load
 * application configuration during app initialization using APP_INITIALIZER.
 *
 * Key Features:
 * - Loads and validates configuration before app startup
 * - Uses APP_INITIALIZER to block app bootstrap until config is loaded
 * - Ensures configuration is available to all services and components
 */

import { APP_INITIALIZER, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfigService } from './config.service';

/**
 * Service module for configuration management.
 *
 * Provides ConfigService and configures APP_INITIALIZER to load
 * configuration before the application starts. This ensures that
 * all configuration is loaded, validated, and available before any
 * components or services are initialized.
 *
 * @class ServiceModule
 */
@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    ConfigService,
    {
      provide: APP_INITIALIZER,
      useFactory: (configService: ConfigService) => () => {
        // SEC-003: console.log entfernt - NGXLogger ist in APP_INITIALIZER nicht verfügbar
        // Config-Loading Fehler werden in ConfigService.loadConfig() geloggt
        return configService.loadConfig();
      },
      deps: [ConfigService],
      multi: true,
    },
  ],
})
export class ServiceModule {}
